import { useState } from "react";
import {
  RiSettings4Line,
  RiNotificationLine,
  RiLockLine,
  RiPaintLine,
  RiUserLine,
  RiGlobalLine,
  RiMailLine,
  RiSaveLine,
  RiBellLine,
} from "react-icons/ri";

const Settings = () => {
  const [activeTab, setActiveTab] = useState("general");
  const [settings, setSettings] = useState({
    general: {
      companyName: "Your Company Name",
      email: "company@example.com",
      phone: "+1 234 567 890",
      timezone: "UTC-5",
      dateFormat: "MM/DD/YYYY",
      currency: "USD",
    },
    notifications: {
      emailNotifications: true,
      pushNotifications: true,
      reminderFrequency: "daily",
      marketingEmails: false,
    },
    appearance: {
      theme: "light",
      sidebarCollapsed: false,
      denseMode: false,
      fontSize: "normal",
    },
    security: {
      twoFactorAuth: false,
      sessionTimeout: "30",
      passwordExpiry: "90",
      loginAttempts: "5",
    },
  });

  const tabs = [
    {
      id: "general",
      name: "General Settings",
      icon: RiSettings4Line,
      description: "Basic configuration options",
    },
    {
      id: "notifications",
      name: "Notifications",
      icon: RiBellLine,
      description: "Manage notification preferences",
    },
    {
      id: "appearance",
      name: "Appearance",
      icon: RiPaintLine,
      description: "Customize the interface",
    },
    {
      id: "security",
      name: "Security",
      icon: RiLockLine,
      description: "Security and authentication settings",
    },
  ];

  const handleSave = () => {
    // Implement settings save functionality
    console.log("Saving settings:", settings);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "general":
        return (
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="label">Company Name</label>
                <input
                  type="text"
                  className="input"
                  value={settings.general.companyName}
                  onChange={(e) =>
                    setSettings({
                      ...settings,
                      general: {
                        ...settings.general,
                        companyName: e.target.value,
                      },
                    })
                  }
                />
              </div>
              <div>
                <label className="label">Email</label>
                <input
                  type="email"
                  className="input"
                  value={settings.general.email}
                  onChange={(e) =>
                    setSettings({
                      ...settings,
                      general: { ...settings.general, email: e.target.value },
                    })
                  }
                />
              </div>
              <div>
                <label className="label">Timezone</label>
                <select
                  className="input"
                  value={settings.general.timezone}
                  onChange={(e) =>
                    setSettings({
                      ...settings,
                      general: {
                        ...settings.general,
                        timezone: e.target.value,
                      },
                    })
                  }
                >
                  <option value="UTC-5">Eastern Time (UTC-5)</option>
                  <option value="UTC-6">Central Time (UTC-6)</option>
                  <option value="UTC-7">Mountain Time (UTC-7)</option>
                  <option value="UTC-8">Pacific Time (UTC-8)</option>
                </select>
              </div>
              <div>
                <label className="label">Date Format</label>
                <select
                  className="input"
                  value={settings.general.dateFormat}
                  onChange={(e) =>
                    setSettings({
                      ...settings,
                      general: {
                        ...settings.general,
                        dateFormat: e.target.value,
                      },
                    })
                  }
                >
                  <option value="MM/DD/YYYY">MM/DD/YYYY</option>
                  <option value="DD/MM/YYYY">DD/MM/YYYY</option>
                  <option value="YYYY-MM-DD">YYYY-MM-DD</option>
                </select>
              </div>
            </div>
          </div>
        );

      case "notifications":
        return (
          <div className="space-y-6">
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="font-medium">Email Notifications</h3>
                  <p className="text-sm text-gray-500">
                    Receive updates via email
                  </p>
                </div>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={settings.notifications.emailNotifications}
                    onChange={(e) =>
                      setSettings({
                        ...settings,
                        notifications: {
                          ...settings.notifications,
                          emailNotifications: e.target.checked,
                        },
                      })
                    }
                  />
                  <span className="slider round"></span>
                </label>
              </div>
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="font-medium">Push Notifications</h3>
                  <p className="text-sm text-gray-500">
                    Get browser notifications
                  </p>
                </div>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={settings.notifications.pushNotifications}
                    onChange={(e) =>
                      setSettings({
                        ...settings,
                        notifications: {
                          ...settings.notifications,
                          pushNotifications: e.target.checked,
                        },
                      })
                    }
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
          </div>
        );

      case "appearance":
        return (
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="label">Theme</label>
                <select
                  className="input"
                  value={settings.appearance.theme}
                  onChange={(e) =>
                    setSettings({
                      ...settings,
                      appearance: {
                        ...settings.appearance,
                        theme: e.target.value,
                      },
                    })
                  }
                >
                  <option value="light">Light</option>
                  <option value="dark">Dark</option>
                  <option value="system">System</option>
                </select>
              </div>
              <div>
                <label className="label">Font Size</label>
                <select
                  className="input"
                  value={settings.appearance.fontSize}
                  onChange={(e) =>
                    setSettings({
                      ...settings,
                      appearance: {
                        ...settings.appearance,
                        fontSize: e.target.value,
                      },
                    })
                  }
                >
                  <option value="small">Small</option>
                  <option value="normal">Normal</option>
                  <option value="large">Large</option>
                </select>
              </div>
            </div>
          </div>
        );

      case "security":
        return (
          <div className="space-y-6">
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="font-medium">Two-Factor Authentication</h3>
                  <p className="text-sm text-gray-500">
                    Enable 2FA for enhanced security
                  </p>
                </div>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={settings.security.twoFactorAuth}
                    onChange={(e) =>
                      setSettings({
                        ...settings,
                        security: {
                          ...settings.security,
                          twoFactorAuth: e.target.checked,
                        },
                      })
                    }
                  />
                  <span className="slider round"></span>
                </label>
              </div>
              <div>
                <label className="label">Session Timeout (minutes)</label>
                <input
                  type="number"
                  className="input"
                  value={settings.security.sessionTimeout}
                  onChange={(e) =>
                    setSettings({
                      ...settings,
                      security: {
                        ...settings.security,
                        sessionTimeout: e.target.value,
                      },
                    })
                  }
                />
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="max-w-full mx-auto space-y-6">
      <h1 className="text-3xl font-bold text-gray-900">Settings</h1>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
        {/* Sidebar */}
        <div className="lg:col-span-1">
          <div className="card">
            <nav className="space-y-1">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  className={`flex items-center gap-2 w-full p-3 rounded-lg transition-colors ${
                    activeTab === tab.id
                      ? "bg-primary-50 text-primary-600"
                      : "hover:bg-gray-50 text-gray-600"
                  }`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  <tab.icon className="w-5 h-5" />
                  <div className="text-left">
                    <div className="font-medium">{tab.name}</div>
                    <div className="text-sm text-gray-500">
                      {tab.description}
                    </div>
                  </div>
                </button>
              ))}
            </nav>
          </div>
        </div>

        {/* Main Content */}
        <div className="lg:col-span-3">
          <div className="card">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="text-xl font-semibold">
                  {tabs.find((tab) => tab.id === activeTab)?.name}
                </h2>
                <p className="text-sm text-gray-500">
                  {tabs.find((tab) => tab.id === activeTab)?.description}
                </p>
              </div>
              <button
                onClick={handleSave}
                className="btn btn-primary flex items-center gap-2"
              >
                <RiSaveLine className="w-5 h-5" />
                Save Changes
              </button>
            </div>

            {renderTabContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
